import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { hex2rgba } from '~/utils';
import { buttonClassName } from '@fluentui/react-northstar';

export const ConfirmationContainer: StyleRule = () => ({
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0,
    zIndex: 99999,
    backgroundColor: hex2rgba('#000', 0.45),
    justifyContent: 'center',
    alignItems: 'center',
});
export const ConfirmationContentArea: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([40, 24]),
    minWidth: pxToRem(450),
    minHeight: pxToRem(230),
    maxWidth: pxToRem(450),
    maxHeight: pxToRem(230),
    background: '#FAF9F7',
    boxShadow: theme.siteVariables.shadowLevel3,
    position: 'relative',

    [theme.screen.max.tablet]: {
        padding: pxArrayToRem([36, 22]),
        minWidth: pxToRem(370),
        maxWidth: pxToRem(370),
        minHeight: pxToRem(225),
        maxHeight: pxToRem(225),
    },
});
export const Title: StyleRule = ({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: pxToRem(22),
    lineHeight: '100%',
    letterSpacing: '-0.02em',
    marginBottom: pxToRem(35),

    [theme.screen.max.tablet]: {
        fontSize: pxToRem(20),
        letterSpacing: 0,
        marginBottom: pxToRem(32),
    },
});
export const Message: StyleRule = () => ({
    fontWeight: 400,
    fontSize: pxToRem(16),
    lineHeight: '130%',
    margin: 0,
});
export const FooterContainer: StyleRule = ({ theme }) => ({
    margin: 0,
    marginLeft: pxToRem(24),
    position: 'absolute',
    bottom: pxToRem(24),
    right: pxToRem(24),

    [theme.screen.max.tablet]: {
        bottom: pxToRem(20),
        right: pxToRem(22),
    },
});
export const FooterDefault: StyleRule = () => ({
    margin: 0,
    gap: pxToRem(7),
});
export const ButtonBase: StyleRule = ({ theme }) => ({
    width: pxToRem(143),
    padding: pxToRem(17.5),

    [theme.screen.max.tablet]: {
        width: pxToRem(126),
    },
});
export const CancelButton: StyleRule = ({ theme }) => ({
    borderColor: theme.siteVariables.colors.charcoal['000'],

    [`&> .${buttonClassName}`]: {
        borderColor: theme.siteVariables.colors.charcoal['000'],
    },
});
